import { createApi } from "@reduxjs/toolkit/query/react"
import { baseQuery } from "../api"
import {
  GetSmsThreadStatsParams,
  SmsThreadStatsResponse
} from "../../types/conversations"
import { SMS_THREAD_STATS_ENDPOINT } from "../../common/constants"

const reducerPath = "smsThreadStatsApi"

export const smsThreadStatsApi = createApi({
  reducerPath,
  baseQuery,
  endpoints: builder => ({
    getSmsThreadStats: builder.query<
      SmsThreadStatsResponse,
      GetSmsThreadStatsParams
    >({
      query: params => ({
        url: SMS_THREAD_STATS_ENDPOINT,
        method: "GET",
        params
      }),
      transformResponse: (response: SmsThreadStatsResponse) => {
        // Check for error status
        if (response.status === "error") {
          console.error("SMS Thread Stats Error:", response.message)
          return response
        }

        return response
      }
    })
  })
})

export const { useGetSmsThreadStatsQuery } = smsThreadStatsApi
